import React from "react";
import * as R from "ramda";

import { DefaultLine } from "components/Line";
import { Section } from "components/Section";
import Text from "components/Text";
import Fields from "components/guides/Fields";
import Footer from "components/guides/ZoningDetails/Footer";
import Header from "components/guides/ZoningDetails/Header";
import ZoningDetails from "components/guides/ZoningDetails/ZoningDetails";
import ZoningMap from "components/guides/summary/ZoningMap";
import { useAnswerContext } from "contexts/answerContext";
import { useCurrentTenant } from "contexts/currentTenant";
import { getAnswer, getAnsweredGuideFieldIdents } from "queries/projects";
import { getIsZoningEnabled } from "reducers/projects";
import { getDisclaimer, getMunicipalityType } from "reducers/tenant";
import { isBlank } from "utils/func";
import { getPermission } from "utils/zoning";

import styles from "./Summary.scss";

const ZoningSummary = () => {
  const { record: project } = useAnswerContext();
  const tenant = useCurrentTenant();
  const zoning = getAnswer(project, "zoning");

  if (isBlank(zoning)) return null;

  const guideFieldIdents = getAnsweredGuideFieldIdents(project);

  const isZoningEnabled = getIsZoningEnabled(project);
  const permission = getPermission(zoning);
  const disclaimer = getDisclaimer(tenant);
  const municipalityType = getMunicipalityType(tenant);

  return (
    <main role="main" data-zoning-summary>
      <Header permission={permission} />
      <div className={styles.mapContainer}>
        <ZoningMap />
      </div>

      <div className={styles.sectionContainer}>
        <ZoningDetails fromSummary />
      </div>

      {!R.isEmpty(guideFieldIdents) && (
        <Section heading={<Text t="guides.summary.project_details" />}>
          <Fields
            fieldIdents={guideFieldIdents}
            behaviorType="disabled"
            className={styles.fieldsSection}
          />
        </Section>
      )}

      <DefaultLine />

      {isZoningEnabled && (
        <Footer
          permission={permission}
          disclaimer={disclaimer}
          municipalityType={municipalityType}
        />
      )}
    </main>
  );
};

export default ZoningSummary;
